import Actor from './actor'
import FormWidgetInputValidationType
	from '../model/form-widget-input-validation-type'
const {
	MINIMUM_LENGTH, MAXIMUM_LENGTH,
	MINIMUM_MAXIMUM_LENGTH, CUSTOM_EXPRESSION
} = FormWidgetInputValidationType

/**
 * Changes the state of a widget on the page
 */
class ChangeWidgetValidationActor extends Actor {

	act() {
		const action = this.options.action
		const widgetId = action.changeWidgetId
		const validation = action.changeWidgetValidation

		const widgetsView = this.options.formDirector?.widgetsView
		if (!widgetsView) return

		const widget = this.model.widgetsById[widgetId]

		// maintain changes to this widget before the rerender
		this.maintainFieldValueFromWidget(widget, widgetsView)

		widget.inputValidationType = validation
		if (validation === MINIMUM_LENGTH) {
			widget.minimumLength = action?.minimumLength
		} else if (validation === MAXIMUM_LENGTH) {
			widget.maximumLength = action?.maximumLength
		} else if (validation === MINIMUM_MAXIMUM_LENGTH) {
			widget.minimumLength = action?.minimumLength
			widget.maximumLength = action?.maximumLength
		} else if (validation === CUSTOM_EXPRESSION) {
			widget.customExpression = action?.customExpression
		}
		widgetsView.updateWidgetView(widget)
	}
}

export default ChangeWidgetValidationActor
ChangeWidgetValidationActor.__filename__ = 'forms/actions/change-widget-validation-actor.js'
